export default __webpack_public_path__ + "static/media/chart-box-active.c42446b1.svg";